import PlaybookModal from '../PlaybookModal'
import * as Datetime from 'react-datetime'

import './style.styl'
import './picker.styl'

const ScheduleModal = ({
  onCloseClick,
  selectedDateTime,
  handleSaveDateTime,
  selectedDateTimeFormatted,
  handleSetDateTime,
}) => (
  <PlaybookModal
    onCloseClick={onCloseClick}
    closeLabel={<div>X</div>}
    hideTitle={true}
    description="Schedule Playbook"
    className={'playbook-schedule-modal'}
    contentClassName="playbook-schedule-modal-content drift-form"
    headerClassName="playbook-schedule-modal-header"
  >
    <div className="playbook-schedule-modal-calendar-panes">
      <div className="playbook-schedule-modal-calendar-pane playbook-schedule-modal-calendar-date">
        <div className="schedule-modal-label">Pick a Date</div>
        <Datetime
          onChange={handleSetDateTime}
          value={selectedDateTime}
          input={false}
          timeFormat={false}
          isValidDate={current => current.isAfter(Datetime.moment().subtract(1, 'day'))}
          className="playbook-schedule-modal-calendar-picker"
        />
      </div>
      <div className="playbook-schedule-modal-calendar-pane playbook-schedule-modal-calendar-time">
        <div className="schedule-modal-label">Pick a Time</div>
        <Datetime
          onChange={handleSetDateTime}
          value={selectedDateTime}
          input={false}
          dateFormat={false}
          isValidDate={current => current.isAfter(Datetime.moment().subtract(1, 'day'))}
          className="playbook-schedule-modal-time-picker"
        />
        <hr />
        <div className="playbook-schedule-modal-summary">
          <div className="playbook-schedule-modal-summary-heading">Schedule this playbook for</div>{' '}
          {selectedDateTimeFormatted}
        </div>
      </div>
    </div>
    <button
      onClick={handleSaveDateTime}
      className="drift-button drift-button-primary playbook-schedule-modal-button"
    >
      Schedule
    </button>
  </PlaybookModal>
)

export default ScheduleModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ScheduleModal/component.js